import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, useNavigate } from 'react-router-dom';
import { AgnesThemeProvider, AgnesToastProvider } from '@agnes/ui';
import App from './App';
import { ConfirmDialog } from './components/ConfirmDialog';
import { setNavigate } from './lib/navigation';
import { useTheme } from './stores/useTheme';
import './lib/devToken';
import './index.css';

// eslint-disable-next-line react-refresh/only-export-components
function NavigationBridge() {
  const nav = useNavigate();
  React.useEffect(() => {
    setNavigate(nav);
  }, [nav]);
  return null;
}

// eslint-disable-next-line react-refresh/only-export-components
function Root() {
  const mode = useTheme((s) => s.mode);
  // AgnesThemeProvider só aplica data-theme num <div display:contents>; Radix (Popover/Select/Modal/Toast)
  // portam pro document.body, fora desse div, e herdariam o tema dark default. Espelhar no <html> faz
  // os portais herdarem os CSS vars do tema atual.
  React.useEffect(() => {
    document.documentElement.dataset.theme = mode;
  }, [mode]);
  return (
    <AgnesThemeProvider mode={mode}>
      <BrowserRouter>
        <NavigationBridge />
        <App />
        <ConfirmDialog />
        <AgnesToastProvider />
      </BrowserRouter>
    </AgnesThemeProvider>
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
);
